import styled from '@emotion/styled';
import { SectionText, SectionTitle } from '@presentation/components';
import { responsiveFontSize } from '@presentation/styles';

export const Title = styled(SectionTitle)`
  ${responsiveFontSize(32, 4)};
`;

export const SubText = styled(SectionText)`
  font-size: 14px;
  margin-top: 26px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 32px;
`;
